import React, { useEffect } from 'react';
import { useState } from 'react';
import ProjectCard from '../../components/ProjectCard/ProjectCard';
import projects from '../../utils/projects';
import './Projects.scss';
import { Tooltip } from 'react-tooltip';

function Projects() {
    const [activeTab, setActiveTab] = useState('Completed');
    const [allProjects, setAllProjects] = useState([]);
    const [displayProjects, setDisplayProjects] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const projectTabs = ['Completed', 'Current'];
    const [filters, setFilters] = useState({
        construction: false,
        expanAndReno: false,
    });

    const iconStyle = {
        color: 'gray',
        size: '14',
    };

    useEffect(() => {
        //scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setAllProjects(projects);
    }, []);

    useEffect(() => {
        updateDisplayProjects(allProjects, activeTab, searchInput, filters);
        // eslint-disable-next-line
    }, [allProjects, activeTab, searchInput, filters]);

    const searchMatch = (project, searchString) => {
        const title = project?.title?.toLowerCase();
        const search = searchString.toLowerCase();
        return title.includes(search);
    };

    const tabMatch = (project, activeTab) => {
        return (
            project?.status ===
            (activeTab === 'Completed' ? 'Completed' : 'In Progress')
        );
    };

    const filterMatch = (project, filters) => {
        if (!!!(filters?.construction ^ filters?.expanAndReno)) return true;

        if (filters?.construction) {
            return project?.type === 'Construction';
        }

        if (filters?.expanAndReno) {
            return project?.type === 'Expansion and Renovation';
        }
    };

    const updateDisplayProjects = (
        allProjects,
        activeTab,
        searchString,
        filters,
    ) => {
        const updatedDisplayProjects = allProjects?.filter(
            (project) =>
                searchMatch(project, searchString) &&
                tabMatch(project, activeTab) &&
                filterMatch(project, filters),
        );
        setDisplayProjects(updatedDisplayProjects);
    };

    return (
        <>
            <section className="page-hero projects-hero top-padding-mobile">
                <div className="page-hero-container">
                    <div className="page-hero-content">
                        <div className="page-hero-badge">Portfolio</div>
                        <h1 className="page-hero-title">
                            Built With Public Partners
                        </h1>
                        <p className="page-hero-description">
                            Explore mechanical builds and retrofits delivered
                            for school boards, municipalities, and general
                            contractors across the GTA. Each project highlights
                            our ability to coordinate trades, protect occupied
                            spaces, and hand over systems that are efficient,
                            reliable, and straightforward for facility teams to
                            operate.
                        </p>
                        <div className="page-hero-stats">
                            <div className="hero-stat-item">
                                <div className="stat-number">50+</div>
                                <div className="stat-label">
                                    Projects Completed
                                </div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">$50M+</div>
                                <div className="stat-label">Total Value</div>
                            </div>
                            <div className="hero-stat-item">
                                <div className="stat-number">100%</div>
                                <div className="stat-label">
                                    On-Time Delivery
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-hero-visual">
                        <svg
                            width="280"
                            height="280"
                            viewBox="0 0 280 280"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                x="40"
                                y="40"
                                width="200"
                                height="200"
                                rx="12"
                                stroke="rgba(0, 175, 207, 0.15)"
                                strokeWidth="2"
                                fill="none"
                            />
                            <rect
                                x="70"
                                y="70"
                                width="140"
                                height="140"
                                rx="8"
                                stroke="rgba(0, 175, 207, 0.2)"
                                strokeWidth="2"
                                fill="none"
                            />
                            <rect
                                x="100"
                                y="100"
                                width="80"
                                height="80"
                                rx="6"
                                fill="rgba(0, 175, 207, 0.08)"
                            />
                            <line
                                x1="40"
                                y1="140"
                                x2="240"
                                y2="140"
                                stroke="rgba(0, 175, 207, 0.15)"
                                strokeWidth="2"
                            />
                            <line
                                x1="140"
                                y1="40"
                                x2="140"
                                y2="240"
                                stroke="rgba(0, 175, 207, 0.15)"
                                strokeWidth="2"
                            />
                        </svg>
                    </div>
                </div>
            </section>

            <section className="section projects-section-main">
                <div className="container">
                    <Tooltip id="projects-disclaimer-tooltip" offset={0} />
                    <div className="projects-header-info">
                        <h2 className="title page-title">
                            Featured Projects
                            <div
                                className="question-icon tooltip"
                                data-tooltip-id="projects-disclaimer-tooltip"
                                data-tooltip-html={
                                    'These include collaborative projects, contracted <br /> by AUZ Mechanical Contracting Services <br /> and executed by Topnotch Mechanical Services Inc.'
                                }
                            >
                                <svg
                                    class="bi bi-info-circle-fill"
                                    fill="currentColor"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    width="16"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
                                </svg>
                            </div>
                        </h2>
                    </div>
                    <div className="project-tabs-wrap">
                        <div className="project-tabs">
                            {projectTabs?.map((tab, index) => (
                                <div className="tab-button" key={index}>
                                    <button
                                        className={
                                            activeTab === tab ? 'active' : ''
                                        }
                                        onClick={() => setActiveTab(tab)}
                                    >
                                        {tab}
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="project-filters-wrap">
                        <div className="search-wrap">
                            <div className="search-icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                    width={iconStyle?.size}
                                    height={iconStyle?.size}
                                    fill={iconStyle?.color}
                                >
                                    <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352c79.5 0 144-64.5 144-144s-64.5-144-144-144S64 128.5 64 208s64.5 144 144 144z" />
                                </svg>
                            </div>
                            <input
                                type={'text'}
                                placeholder="Search projects"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                            />
                            {searchInput && (
                                <div
                                    className="cross-icon"
                                    onClick={() => setSearchInput('')}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                        width={16}
                                        height={16}
                                        fill={iconStyle?.color}
                                    >
                                        <path d="M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" />
                                    </svg>
                                </div>
                            )}
                        </div>
                        <div className="filters">
                            <div
                                className={`filter ${filters?.construction ? 'active-filter' : ''}`}
                                onClick={() =>
                                    setFilters({
                                        ...filters,
                                        construction: !filters?.construction,
                                    })
                                }
                            >
                                {filters?.construction ? (
                                    <svg viewBox="0 0 448 512">
                                        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 448 512">
                                        <path d="M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z" />
                                    </svg>
                                )}
                                Constructions
                            </div>
                            <div
                                className={`filter ${filters?.expanAndReno ? 'active-filter' : ''}`}
                                onClick={() =>
                                    setFilters({
                                        ...filters,
                                        expanAndReno: !filters?.expanAndReno,
                                    })
                                }
                            >
                                {filters?.expanAndReno ? (
                                    <svg viewBox="0 0 448 512">
                                        <path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
                                    </svg>
                                ) : (
                                    <svg viewBox="0 0 448 512">
                                        <path d="M384 32C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96C0 60.65 28.65 32 64 32H384zM384 80H64C55.16 80 48 87.16 48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80z" />
                                    </svg>
                                )}
                                Expansions and Renovations
                            </div>
                        </div>
                    </div>

                    <div className="section-content projects-wrap">
                        {displayProjects?.map((project, index) => (
                            <ProjectCard
                                key={index}
                                project={project}
                                index={index}
                            />
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Projects;
